module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/User-c0497d73e4c6dcb4aa91286a90248c34c054d2811e9fa74bd3ea42c757e8206e.svg";